import React from 'react';
import { Modal } from './components.jsx';
import * as T from '../time.js';
import { Button, Field } from './ds/fgcp-ds.jsx';

// leave-common.jsx — 휴가 화면·휴가 관리 탭이 함께 쓰는 것(날짜 표시, 취소 확인 창).

export const PART_LABEL = { am: '오전', pm: '오후' };

/** 서버가 정한 기간(시각)을 사용자 날짜로 — 'MM/DD' 또는 'MM/DD~MM/DD', 반일이면 오전·오후 */
export function leaveDates(r) {
  // 앱 시간대의 날로(계획 문서 5.3 3d)
  const one = T.md(r.starts_at) + (PART_LABEL[r.day_part] ? ' ' + PART_LABEL[r.day_part] : '');
  return T.ymd(r.starts_at) === T.ymd(r.ends_at) ? one : `${T.md(r.starts_at)}~${T.md(r.ends_at)}`;
}

/**
 * 휴가 취소 확인 — 진행 중이면 결재 회수, 승인 뒤면 잔여 되돌림·부재 일정 취소. 누가 할 수 있는지(actions.cancel)와 사유가 필요한지
 * (actions.cancelReasonRequired — 휴가 관리자의 예외 처리)는 서버가 정한다.
 */
export function LeaveCancelModal({ req, onClose, onConfirm }) {
  const [reason, setReason] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  const required = req.actions?.cancelReasonRequired === true;
  const own = req.status === 'submitted';
  return (
    <Modal width={440} title="휴가 취소" icon="umbrella" onClose={onClose}
      footer={<React.Fragment>
        <Button variant="secondary" size="sm" onClick={onClose}>닫기</Button>
        <Button variant="danger" size="sm" disabled={busy || (required && !reason.trim())}
          onClick={() => { setBusy(true); onConfirm(reason.trim() || null).finally(() => setBusy(false)); }}>취소하기</Button>
      </React.Fragment>}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div style={{ fontSize: 13, lineHeight: 1.7 }}>
          {req.user_name && <b>{req.user_name} · </b>}<b>{req.type_name} {leaveDates(req)}</b> ({Number(req.amount_days)}일)
          {own
            ? ' — 결재를 회수하고 신청을 취소합니다. 결재자에게 회수를 알립니다.'
            : ' — 승인된 휴가를 취소합니다. 차감된 잔여는 돌아오고, Outlook 부재 일정은 취소되며, 결재한 사람에게 알립니다.'}
        </div>
        <Field label={required ? '사유 (필수 — 휴가 관리자의 예외 처리)' : '사유 (선택)'} value={reason} onChange={e => setReason(e.target.value)}
          placeholder="취소 사유" aria-label="취소 사유" maxLength={500} />
      </div>
    </Modal>
  );
}
